export default __webpack_public_path__ + "124f2ee3ed89aba11f5f71fbfec94d81.jpg";